import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import BreadCrumb from '../../components/breadCrumb';
import UserItem from '../../components/adminSchools/userItem';
import './style.scss';

function UserListAdmin() {
  // STATES //
  const [searchParams] = useSearchParams();
  const [querys, setQuerys] = useState('');

  const groupData = [
    {
      name: 'Jaime Francisco Aguayo González	',
      typeId: 'CC',
      dni: '121454326',
      age: {
        from: '7',
        to: '10'
      },
      school: 'E1C1'
    },
    {
      name: 'Chávez Heredia	Andrea',
      typeId: 'TI',
      dni: '121454325',
      age: {
        from: '7',
        to: '10'
      },
      school: 'E1C1'
    },
    {
      name: 'Cortés Lagunes	Ruth Silvana',
      typeId: 'TI',
      dni: '121543265',

      age: {
        from: '7',
        to: '10'
      },
      school: 'E1C1'
    },
    {
      name: 'Delgado Barrón	Luis Felipe',
      typeId: 'TI',
      dni: '114543265',

      age: {
        from: '7',
        to: '10'
      },
      school: 'E1C1'
    },
    {
      name: 'Espejo Ramos	Hansel Andres',
      typeId: 'TI',
      dni: '12153265',

      age: {
        from: '7',
        to: '10'
      },
      school: 'E1C1'
    },
    {
      name: 'Flores Aguilar	Aniyensy Sarai',
      typeId: 'TI',
      dni: '14543265',

      age: {
        from: '7',
        to: '10'
      },
      school: 'E1C1'
    },
    {
      name: 'García Arreguín	Montserrat Carolina',
      typeId: 'TI',
      dni: '1214543',

      age: {
        from: '7',
        to: '10'
      },
      school: 'E1C1'
    }
  ];

  useEffect(() => {
    setQuerys(Object.fromEntries(searchParams));
  }, []);

  return (
    <section className='usersTable-main-container'>
      <BreadCrumb />
      <section className='usersTable-container'>
        <div className='table-top'>
          <p className='title'>
            LISTA DE BENEFICIARIOS INSCRITOS{' '}
            {querys ? querys.escuela?.toUpperCase() : ''} <span> - </span>
            {querys ? querys.group?.toUpperCase() : ''}
          </p>
          <p className='pagination-text'>
            | Mostrando <span>12</span> de <span>24</span> resultados |
          </p>
        </div>
        <div className='users-container'>
          <UserItem groupData={groupData} />
        </div>
      </section>
    </section>
  );
}
export default UserListAdmin;
